import * as React from 'react'

import BlueGridContainer from 'components/blue-grid-container/BlueGridContainer'
import { Text, TextName } from 'sdk'

import { useWindowSize } from 'core/hooks/useWindowSize'
import { renderTextWithBold } from 'core/utils/renderTextWithBold'
import type { ResourcesTechnicalOverviewCmsContent } from 'core/services/cms/interfaces'

import classes from './TechnicalOverviewSection.module.scss'

interface TechnicalOverviewSectionProps {
  content: ResourcesTechnicalOverviewCmsContent
}

export const TechnicalOverviewSection: React.FC<TechnicalOverviewSectionProps> = ({ content }) => {
  const { width } = useWindowSize()
  const isAboveMd = width > 768

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Text type={TextName.H2}>{content.title}</Text>
        <Text type={TextName.Text}>
          {content.body}
        </Text>
      </div>

      <BlueGridContainer className={classes.blueGridContainer}>
        <img
          src={isAboveMd ? content.desktopBackgroundUrl : content.mobileBackgroundUrl}
          alt='GEARS'
          className={classes.backgroundImage}
        />
      </BlueGridContainer>

      <div className={classes.featuresContainer}>
        {content.points.map((point) => (
          <div key={point.text} className={classes.featureItem}>
            <img src={point.iconUrl} alt='' className={classes.icon} />
            <div className={classes.featureText}>
              {renderTextWithBold(point.text, classes.inlineText)}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
